import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Emoji + accent color + timings for each market. Matches backend MARKETS_META.
export const MARKET_META = {
    shillong_morning: {
        name: "Shillong Morning Teer",
        fr_time: "10:30 AM",
        sr_time: "11:30 AM",
        accent: "#16A34A",   // emerald green
        emoji: "🌅",
    },
    morning_teer: {
        name: "Morning Sunday Teer",
        fr_time: "10:30 AM",
        sr_time: "11:30 AM",
        accent: "#65A30D",   // lime green
        emoji: "☀️",
    },
    morning_teer_live: {
        name: "Morning Teer Live",
        fr_time: "10:30 AM",
        sr_time: "11:30 AM",
        accent: "#DB2777",   // pink
        emoji: "📡",
    },
    bhutan_morning: {
        name: "Bhutan Morning Teer",
        fr_time: "10:30 AM",
        sr_time: "11:30 AM",
        accent: "#0891B2",   // cyan
        emoji: "🏔️",
    },
    guwahati_morning: {
        name: "Guwahati Morning Teer",
        fr_time: "10:30 AM",
        sr_time: "11:30 AM",
        accent: "#4F46E5",   // indigo
        emoji: "🌇",
    },
    juwai: {
        name: "Juwai Teer",
        fr_time: "02:45 PM",
        sr_time: "03:25 PM",
        accent: "#FACC15",   // yellow
        headerTextColor: "#0B1533",
        emoji: "🎯",
    },
    bhutan: {
        name: "Bhutan Teer",
        fr_time: "04:00 PM",
        sr_time: "05:00 PM",
        accent: "#EA580C",   // orange
        emoji: "🏔️",
    },
    shillong_teer: {
        name: "Shillong Teer",
        fr_time: "04:15 PM",
        sr_time: "05:15 PM",
        accent: "#1E3A8A",   // navy blue
        emoji: "🎯",
    },
    khanapara: {
        name: "Khanapara Teer",
        fr_time: "04:15 PM",
        sr_time: "05:15 PM",
        accent: "#DC2626",   // red
        emoji: "🏹",
    },
    my_night_teer: {
        name: "My Night Teer",
        fr_time: "08:00 PM",
        sr_time: "09:00 PM",
        accent: "#0D9488",   // teal
        emoji: "⭐",
    },
    lucky_night: {
        name: "Lucky Night Teer",
        fr_time: "10:00 PM",
        sr_time: "11:00 PM",
        accent: "#7C3AED",   // purple
        emoji: "🍀",
        special: true,
    },
    night_teer: {
        name: "Night Teer",
        fr_time: "11:25 PM",
        sr_time: "12:25 AM",
        accent: "#0F1E4A",   // dark navy
        emoji: "🌙",
    },
};

export const MARKET_ORDER = [
    "shillong_morning",
    "morning_teer",
    "morning_teer_live",
    "bhutan_morning",
    "guwahati_morning",
    "juwai",
    "bhutan",
    "shillong_teer",
    "khanapara",
    "my_night_teer",
    "lucky_night",
    "night_teer",
];
